import { Tab } from "@headlessui/react";
import React, { Fragment } from "react";
import RequestAppointment from "./RequestAppointment";
import { Link } from "react-router-dom";
import AppointmentList from "./AppointmentList";

const PatientAppointments = () => {
  return (
    <section className="min-h-screen px-6 pb-24 relative bg-primary text-white">
      <div className="flex items-center mb-5">
        <Link to={-1} className="mr-3">
          <svg
            width="6"
            height="10"
            viewBox="0 0 10 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.42402 16.2142C9.99277 15.6454 9.99277 14.7267 9.42402 14.1579L3.76569 8.49959L9.42402 2.84126C9.99277 2.27251 9.99277 1.35376 9.42402 0.785009C8.85527 0.216259 7.93652 0.216259 7.36777 0.785009L0.674024 7.47876C0.105274 8.04751 0.105274 8.96626 0.674024 9.53501L7.36777 16.2288C7.92194 16.7829 8.85527 16.7829 9.42402 16.2142Z"
              fill="#fff"
            />
          </svg>
        </Link>
        <h3 className="text-white text-[14px] font-semibold">
          My Appointments
        </h3>
      </div>
      <Tab.Group>
        <Tab.List className="">
          <Tab as={Fragment}>
            {({ selected }) => (
              <button
                className={`shrink-0 w-6/12 px-4 py-3 outline-none rounded-sm bg-gradient-to-b ${
                  selected ? "from-secondary" : "from-[#44148B]"
                } to-transparent text-white text-sm font-semibold`}
              >
                My Request
              </button>
            )}
          </Tab>
          <Tab as={Fragment}>
            {({ selected }) => (
              <button
                className={`shrink-0 w-6/12 px-4 py-3 outline-none rounded-sm bg-gradient-to-b ${
                  selected ? "from-secondary" : "from-[#44148B]"
                } to-transparent text-white text-sm font-semibold`}
              >
                Request History
              </button>
            )}
          </Tab>
        </Tab.List>
        <Tab.Panels>
          <Tab.Panel>
            <RequestAppointment />
          </Tab.Panel>
          <Tab.Panel>
            <AppointmentList />
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </section>
  );
};

export default PatientAppointments;
